import { LOGO_URL } from "@/data/content";

/**
 * Official TA CLÉ INVEST logo lockup.
 * On dark surfaces (footer, hero over dark image) we invert the artwork
 * so the anthracite text becomes light while preserving legibility.
 * The copper "TC" monogram survives the invert well enough for footer use;
 * for a pure brand-mark render, `mark-only` is available.
 */
export default function Logo({ tone = "dark", size = 40, className = "", markOnly = false }) {
  const isLight = tone === "light";

  // On dark surfaces we render a clean monochrome (bone) silhouette of the lockup.
  // This preserves the shape/hierarchy of the brand mark without the muddy hue-shift
  // that a partial invert would cause on the copper emblem.
  const filterStyle = isLight
    ? { filter: "brightness(0) invert(1)" }
    : undefined;

  const width = markOnly ? size : size * 4.3; // full lockup aspect ~4.3:1

  return (
    <div
      className={`flex items-center ${className}`}
      aria-label="TA CLÉ INVEST Gayrimenkul Yatırım ve Finans A.Ş."
      style={{ lineHeight: 0 }}
    >
      <img
        src={LOGO_URL}
        alt="TA CLÉ INVEST"
        style={{
          height: markOnly ? size : size,
          width: markOnly ? size : "auto",
          maxWidth: width,
          objectFit: "contain",
          objectPosition: markOnly ? "left top" : "left center",
          ...filterStyle,
        }}
        draggable={false}
      />
    </div>
  );
}
